<template>
    <SmartLinkItemComponent :id="`_${model.system.id}`" :component="!model.system.workflow" v-if="model">
        <div class="split-content-block-image" v-if="model">
            <SmartLinkStandaloneElement :codename="type.elements.image.codename">
                <NuxtImg class="img-fluid" provider="kontentAiProvider" v-if="model?.elements?.image?.value"
                    :src="firstOrDefault(model.elements.image.value)?.url" />
                <div class="img-caption" :class="captionClass" v-if="!isEmpty(model.elements.caption.value)">
                    <RichText :value="model.elements.caption.value"/>
                </div>
            </SmartLinkStandaloneElement>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { type SplitContentBlockImageModel, contentTypes } from '~~/app/models';
const type = contentTypes.split_content_block_image;
const props = defineProps<{ model: SplitContentBlockImageModel }>();

const captionClass = computed(() => firstOrDefault(props.model.elements.caption_styling.value)?.codename ?? 'light');
</script>